// src/utils/i18nFormatters.js
// Formatage locale-aware centralisé (dates / nombres / devises).
// Remplace progressivement les toLocaleString('fr-FR') câblés (S2+).
// Voir docs/PLAN_I18N_MULTILANGUE.md §6.4.

import { format, parseISO } from 'date-fns'
import { fr, enUS, es, it } from 'date-fns/locale'
import { normalizeLocale } from './locales'

const DATE_FNS_LOCALES = { fr, en: enUS, es, it }

export function getDateFnsLocale(lang) {
  return DATE_FNS_LOCALES[normalizeLocale(lang)] || fr
}

// pattern = format date-fns ('P' = date courte localisée, 'PP', 'PPP', etc.)
export function formatDateI18n(date, pattern = 'P', lang) {
  if (!date) return ''
  const d = typeof date === 'string' ? parseISO(date) : date
  try {
    return format(d, pattern, { locale: getDateFnsLocale(lang) })
  } catch {
    return ''
  }
}

export function formatNumberI18n(num, lang) {
  if (num === null || num === undefined || Number.isNaN(Number(num))) return ''
  return new Intl.NumberFormat(normalizeLocale(lang)).format(num)
}

export function formatCurrencyI18n(num, { currency = 'EUR', lang } = {}) {
  if (num === null || num === undefined || Number.isNaN(Number(num))) return ''
  return new Intl.NumberFormat(normalizeLocale(lang), { style: 'currency', currency }).format(num)
}
